var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFixtabWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.553 132.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1916",
    "data-name": "Group 1916",
    transform: "translate(348 -3605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M108.19,129.43H30A10.55,10.55,0,0,0,19.4,140V251.35A10.55,10.55,0,0,0,30,261.9h78.24a10.55,10.55,0,0,0,10.56-10.55V140a10.56,10.56,0,0,0-10.61-10.57Zm-57.67,82.8H38a2,2,0,0,1-2-2V148a2,2,0,0,1,2-2H67.08a2,2,0,0,1,2,2v12.57a2,2,0,0,1-2,2H54.51a2,2,0,0,0-2,2v12.58a2,2,0,0,0,2,2H67.08a2,2,0,0,1,2,2v12.58a2,2,0,0,1-2,2H54.51a2,2,0,0,0-2,2V210.3a2,2,0,0,1-1.99,1.93Zm18.55,31.12a2,2,0,0,1-2,2H54.51a2,2,0,0,1-2-2V230.78a2,2,0,0,1,2-2H67.08a2,2,0,0,1,2,2Zm33.12-31.12v31.12a2,2,0,0,1-2,2H87.63a2,2,0,0,1-2-2V214.22a2,2,0,0,0-2-2H71.07a2,2,0,0,1-2-2V197.66a2,2,0,0,1,2-2H100.2a2,2,0,0,1,2,2Z",
    transform: "translate(-367.4 3475.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3651",
    "data-name": "Rectangle 3651",
    width: 16.56,
    height: 16.56,
    rx: 1.99,
    transform: "translate(-281.77 3638.12)",
    fill: "#d83039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M145.61,225.03h12.01V203.02H178.7V192.94H157.62V181.78h23.7V171.7H145.61Z",
    transform: "translate(-367.4 3475.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3652",
    "data-name": "Rectangle 3652",
    width: 11.47,
    height: 40.48,
    transform: "translate(-174.54 3660.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M198.56,166.08a6.838,6.838,0,0,0-4.81,11.73,7.3,7.3,0,0,0,9.62,0,6.773,6.773,0,0,0-4.81-11.73Z",
    transform: "translate(-367.4 3475.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M286.71,215.91a21.862,21.862,0,0,1-3.81.35c-2.56,0-4.27-.72-5.11-2.16a11.3,11.3,0,0,1-1.27-5.77V194.09h13.77v-9.54H276.52V172.62l-11.47,1.85v34a32.3,32.3,0,0,0,.73,7.16,13.17,13.17,0,0,0,2.58,5.5,12.06,12.06,0,0,0,4.92,3.54,20.52,20.52,0,0,0,7.78,1.27,26.929,26.929,0,0,0,6.23-.61,32.193,32.193,0,0,0,4.62-1.47L290.29,215a19.64,19.64,0,0,1-3.58.91Z",
    transform: "translate(-367.4 3475.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M330.35,187.93a13.11,13.11,0,0,0-5.43-3.3,26.53,26.53,0,0,0-8.46-1.16c-1.34,0-2.66.07-4,.19s-2.55.29-3.73.47-2.27.38-3.27.61-1.84.45-2.5.65l1.46,9.24a24.941,24.941,0,0,1,4.93-1.19,38.06,38.06,0,0,1,5.77-.43q4.38,0,6.16,1.77a6.37,6.37,0,0,1,1.77,4.7v1.08a16.4,16.4,0,0,0-2.81-.5,35.855,35.855,0,0,0-4-.2,30.352,30.352,0,0,0-6.38.66,17.14,17.14,0,0,0-5.47,2.11,11,11,0,0,0-3.81,3.93,11.79,11.79,0,0,0-1.42,6,14.281,14.281,0,0,0,1.23,6.24,10.36,10.36,0,0,0,3.54,4.11,15.26,15.26,0,0,0,5.5,2.27,33.762,33.762,0,0,0,7.12.7,65.34,65.34,0,0,0,10.62-.74c2.93-.48,5.21-.91,6.85-1.27V200a25.542,25.542,0,0,0-.85-6.85,12.16,12.16,0,0,0-2.82-5.22Zm-7.27,28.79a23,23,0,0,1-2.47.23c-1,.05-2.1.08-3.23.08a10,10,0,0,1-5-1,3.94,3.94,0,0,1-1.81-3.74,4,4,0,0,1,.61-2.3,4.29,4.29,0,0,1,1.7-1.47,8,8,0,0,1,2.5-.73,24.186,24.186,0,0,1,3-.19,23.83,23.83,0,0,1,2.54.15c.92.11,1.61.21,2.08.31Z",
    transform: "translate(-367.4 3475.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M384.8,196.13a19.21,19.21,0,0,0-3.39-6.66,15,15,0,0,0-5.54-4.27,18.311,18.311,0,0,0-7.62-1.5,21,21,0,0,0-4.46.46,21.781,21.781,0,0,0-4,1.31V165.31l-11.47,1.84v56.57c1,.31,2.21.6,3.54.89s2.73.52,4.19.73,2.95.37,4.47.5,3,.19,4.35.19a24.829,24.829,0,0,0,8.92-1.5,18.19,18.19,0,0,0,6.62-4.27,18.5,18.5,0,0,0,4.12-6.7,25.531,25.531,0,0,0,1.42-8.77,30.36,30.36,0,0,0-1.15-8.66ZM371.87,213a8.23,8.23,0,0,1-7.08,3.24q-1.55,0-2.85-.12c-.87-.08-1.59-.16-2.15-.27V195a10,10,0,0,1,2.8-1.15,13.531,13.531,0,0,1,3.51-.46q8.14,0,8.16,11.08a14,14,0,0,1-2.39,8.53Z",
    transform: "translate(-367.4 3475.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M243.1,184.48l-8.08,11.47-8.08-11.47h-12.4l14.28,20.27-14.28,20.28h12.4l8.08-11.48,8.08,11.48h12.39l-14.28-20.28,14.28-20.27Z",
    transform: "translate(-367.4 3475.57)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFixtabWhite);
export default __webpack_public_path__ + "static/media/logo-fixtab-white.39927a28.svg";
export { ForwardRef as ReactComponent };